import React, { Component } from 'react';
import Icons from "../../../icon";
import { InputGroup,FormControl } from "react-bootstrap";
import ButtonIcon from "../../../button";
export class OrderHistory extends Component {
    closeOrderDetails=()=>{
       this.props.openCircuitDetail(true)
    }
    render(){
        return(
            <>
            <div className='header-right-container'>
                <div>

                </div>
               <div className='order-list-buttton-container'>
                <ButtonIcon onClick={this.props.renderGrid} iconLeft={"cloud-arrow-up"} iconSize="16px" labelName="Upload Scada" customClassName="history-upload-btn"/>
                    <InputGroup size="sm" className="request-input-header header-input">
                            <InputGroup.Text id="inputGroup-sizing-sm">
                            <Icons name="search" customClassName="icon-search" size="12px" />
                            </InputGroup.Text>
                            <FormControl
                            placeholder="Search..."
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                        />                  
                    </InputGroup>
                    <ButtonIcon onClick={this.props.renderList} iconLeft={"list-regular"} iconSize="16px" customClassName="table-icon-list"/>
                    <ButtonIcon onClick={this.props.renderGrid} iconLeft={"th-solid"} iconSize="16px" customClassName="table-icon-grid"/>
               </div>
            </div>
                
                <div className='order-history-container'>                
                <div className='order-add-history-container'>
                    <Icons
                        name="plus-regular"
                        size="30px"
                        customClassName="icon-plus-regular"                   
                    />
                </div>
                <div className='order-history-blue-container'>
                    <div className='order-history-update-container'>
                        <Icons
                            name="pen-light"
                            size="16px"
                            customClassName="icon-pen-light"   
                            onClick={()=>{alert("edit item")}}                
                        />
                        <span>|</span>
                        <Icons
                            name="trash-can"
                            size="16px"
                            customClassName="icon-trash-regular"  
                            onClick={()=>{alert("delete item")}}                  
                        />
                    </div>
                    <div className='order-history-list-container' onClick={this.closeOrderDetails.bind(this)}>
                        <div className='order-history-label-container'>
                            <span className='order-history-title'>CIRCUIT ID:</span>
                            <span>ID12344</span>
                        </div>
                        <div className='order-history-label-container'>
                            <span className='order-history-title'>TYPE:</span><br/>
                            <span>Lorem Ipsum</span>
                        </div>
                        <div className='order-history-label-container'>
                            <span className='order-history-title'>Account NO:</span>
                            <span>01234567890</span>
                        </div>
                    </div>                    
                </div>
            </div>

            </>            
        )
    }
}